import React from 'react';
import CircleIconButton from "../buttons/CircleIconButton";
import {toPersianNumber} from "../utils/StringUtility";

import ICArrowLeft from '@material-ui/icons/ArrowBackIos';
import ICArrowRight from '@material-ui/icons/ArrowForwardIos';

export default function Pagination(props) {

    let dotCount = 0

    return (<div>
        <div className="horizontalScreen center marginTopBottomSmall">
            <div className="marginLeftRightMedium">
                <CircleIconButton
                    disabled={(props.pages && props.pages[0].selected)}
                    hover={"var(--blue_3)"}
                    background={"var(--orange_3)"}
                    width={"1.5em"} height={"1.5em"}
                    icon={<ICArrowRight
                        style={{
                            fill: (props.pages && props.pages[0].selected) ?
                                "var(--gray_4)" : "var(--white)"
                        }}/>}
                    onClick={props.onBackClick}/>
            </div>
            {props.pages &&
            (props.pages.map((page, index) => {
                if (index >= 3 && index < props.pages.length - 1) {
                    dotCount += 1
                    if (dotCount < 3) {
                        return (<div key={index} className="paddingXSmall marginLeftRightSmall">.</div>)
                    } else {
                        return (<div key={index}/>)
                    }
                } else {
                    return (<div key={index} className="marginLeftRightSmall">
                        <CircleIconButton
                            hover={page.selected ? "var(--gray_2)" : "var(--gray_3)"}
                            background={page.selected ? "var(--gray_3)" : "var(--gray_1)"}
                            width={"1.5em"} height={"1.5em"}
                            text={<div className={page.selected ? "redColor" : "grayColor"}>
                                {page.number && toPersianNumber(page.number.toString())}
                            </div>}
                            onClick={() => {
                                props.onNumberClick(page.number)
                            }}/>
                    </div>)
                }
            }))
            }
            <div className="marginLeftRightMedium">
                <CircleIconButton
                    disabled={(props.pages && props.pages[props.pages.length - 1].selected)}
                    hover={"var(--blue_3)"}
                    background={"var(--orange_3)"}
                    width={"1.5em"} height={"1.5em"}
                    icon={<ICArrowLeft
                        style={{
                            fill: (props.pages && props.pages[props.pages.length - 1].selected) ?
                                "var(--gray_4)" : "var(--white)"
                        }}/>}
                    onClick={props.onNextClick}/>
            </div>
        </div>
    </div>)
}